import polyglotI18nProvider from 'ra-i18n-polyglot';
import messagesFrancais from 'ra-language-french';

/**
 * **La surface parle français, et la peau parle anglais par défaut.**
 *
 * `src/lib/i18nProvider.ts` fait partie des 117 fichiers recopiés : il monte
 * `ra-language-english` et déclare `en`. **On ne le retouche pas** — `verifier-la-peau.mjs`
 * rougirait, et c'est son objet. On passe celui-ci à `<Admin>`, qui prend `i18nProvider` en
 * propriété : la peau n'utilise le sien que lorsqu'aucun n'est fourni.
 *
 * Le produit est francophone de bout en bout — le corpus, les codes d'erreur métier mis à
 * part, et les libellés de `web/` et `site/`. Une surface d'administration en anglais au
 * milieu serait la seule.
 *
 * **`allowMissing` est vrai, et ce n'est pas un relâchement.** Un libellé manquant s'affiche
 * alors sous sa clef, ce qui est laid et lisible ; sans lui, `ra-core` lève, et **un libellé
 * oublié ferait tomber un écran entier**. Sur une surface interne dont « la valeur est
 * d'exister, pas d'être beau » (§7), le bon sens du défaut est celui-là.
 */
/**
 * ═══════════════════════════════════════════════════════════════════════════
 * **LE PIED DE LISTE NE PROMET PLUS UN TOTAL QU'IL N'A PAS.**
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * **Le libellé français d'origine est `%{offsetBegin}-%{offsetEnd} sur %{total}`**, et il
 * suppose une pagination qui connaît le nombre de lignes de la table. **La nôtre ne le
 * connaît pas** : `DOCTRINE.md` §5 impose le curseur, précisément pour n'avoir aucun
 * `COUNT`.
 *
 * En recette, le 20260825, le pied de **toutes** les listes affichait donc ses gabarits en
 * clair — `1-%{offsetEnd} sur %{total}`. `curseurs.ts` fournit désormais le total **sur la
 * dernière page**, où il se déduit sans compter ; mais **dès qu'il y a une suite il reste
 * inconnaissable**, et `%{total}` fuirait encore.
 *
 * **`%{total}` est donc retiré du libellé, et ce n'est pas un appauvrissement.** Un total
 * estimé, ou celui de la page courante présenté comme le total, afficherait **un chiffre
 * faux avec l'aplomb d'un vrai** — le seul défaut pire qu'un gabarit en clair. Les deux
 * bornes restantes sont toujours définies, et elles disent exactement ce qu'on sait.
 *
 * **Pourquoi ici et non dans la peau.** `list-pagination.tsx` est l'un des 117 fichiers
 * recopiés : le retoucher ferait rougir `verifier-la-peau.mjs`, et c'est son objet. Le
 * libellé, lui, appartient au produit — c'est le bon endroit pour cet arbitrage.
 */
const MESSAGES = {
  ...messagesFrancais,
  ra: {
    ...messagesFrancais.ra,
    navigation: {
      ...messagesFrancais.ra.navigation,
      page_range_info: '%{offsetBegin}–%{offsetEnd}',
    },
  },
};

export const fournisseurDeLangue = polyglotI18nProvider(
  () => MESSAGES,
  'fr',
  [{ locale: 'fr', name: 'Français' }],
  { allowMissing: true },
);
